import * as React from "react";
import { IExpenseTradeItemCreate } from 'src/services/interfaces/Expense/IExpenseTradeItemCreate';
import { Row } from 'antd';
import "./ExpenseViewTradeInfo.scss";

interface IExpenseViewTradeInfoProps {
    expenseItem: IExpenseTradeItemCreate;
}

export const ExpenseViewTradeInfo: React.FC<IExpenseViewTradeInfoProps> = ({
    expenseItem
}) => (
        <>
            <span className="id-header-card">Trade ID</span>
            <span className="id-card">{expenseItem.tradeId}</span>
            <Row gutter={24} className="description">
                <span>
                    <b>Nome:</b> {expenseItem.tradeName}
                </span>
            </Row>
            <Row gutter={24} className="description">
                <span>
                    <b>CPF:</b> {expenseItem.tradeCpf}
                </span>
            </Row>
            <Row gutter={24} className="description">
                <span>
                    <b>Fase: </b>
                    {expenseItem.tradePhase}
                </span>
            </Row>
        </>
    );


// WEBPACK FOOTER //
// ./src/components/common/ExpenseItemCard/ExpenseViewTradeInfo/ExpenseViewTradeInfo.tsx